var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F0B90B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79207 6.6464L12.0001 4.2854L16.2091 6.6464L14.6661 7.5204L12.0001 6.0294L9.34007 7.5194L7.79207 6.6464ZM16.2091 9.6294L14.6661 8.7554L12.0001 10.2464L9.34007 8.7554L7.79307 9.6294V11.3734L10.4501 12.8654V15.8434L12.0011 16.7174L13.5481 15.8434V12.8654L16.2101 11.3734L16.2091 9.6294ZM16.2091 14.3564V12.6094L14.6661 13.4834V15.2274L16.2091 14.3564ZM17.3101 14.9734L14.6491 16.4604V18.2094L18.8571 15.8434V11.1204L17.3101 11.9904V14.9734ZM15.7631 8.1394L17.3061 9.0134V10.7574L18.8571 9.8874V8.1394L17.3101 7.2644L15.7631 8.1434V8.1394ZM10.4491 17.0964V18.8404L12.0001 19.7144L13.5471 18.8404V17.0994L12.0001 17.9694L10.4531 17.0954L10.4491 17.0964ZM7.79207 14.3534L9.33507 15.2274V13.4834L7.79207 12.6084V14.3584V14.3534ZM10.4491 8.1394L12.0001 9.0124L13.5471 8.1384L12.0001 7.2634L10.4531 8.1424L10.4491 8.1394ZM6.69007 9.0134L8.23707 8.1394L6.69407 7.2644L5.14407 8.1434V9.8894L6.69007 10.7594V9.0134ZM6.69007 11.9914L5.14307 11.1214V15.8444L9.35207 18.2104V16.4574L6.69407 14.9694V11.9864L6.69007 11.9914Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.84dc062791548499d48afe928c0e7795.svg";
export { ForwardRef as ReactComponent };